module.exports = __webpack_public_path__ + "static/media/X.f4a2b363.svg";